import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CashCodingModel } from '@app/core/Models';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { CommonService } from '../..';

@Injectable({
  providedIn: 'root',
})
export class CashCodingService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  createCashCoding(cash: CashCodingModel[]): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(
      `${environment.apiVersionUrl}cashCoding/insert`,
      this.commonService.trimObjectSpace(JSON.stringify(cash)),
      headers
    );
  }
}
